import { event } from "@/utils/promises"


export const [onCartLoaded, setCartLoaded] = event();



